"use strict";const _jsxFileName = "/home/runner/work/bloom-mono/bloom-mono/apps/frontend/webChat/src/screens/Super/SuperUsersScreen.tsx";Object.defineProperty(exports, "__esModule", {value: true}); function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }var _react = require('react'); var _react2 = _interopRequireDefault(_react);
var _client = require('shared/services/client'); var _client2 = _interopRequireDefault(_client);
var _log = require('shared/log');
var _useSearchQuery = require('shared/hooks/useSearchQuery');

var _Name = require('web/components/Name'); var _Name2 = _interopRequireDefault(_Name);
var _Form = require('web/components/Form');
var _SuperTableTR = require('web/components/Super/SuperTableTR'); var _SuperTableTR2 = _interopRequireDefault(_SuperTableTR);


const UserResult = ({ user }) => {
  return (
    _react2.default.createElement(_SuperTableTR2.default, { to: `/super/users/${user.UserKey}`, __self: this, __source: {fileName: _jsxFileName, lineNumber: 13}}
      , _react2.default.createElement('td', { className: "uuid", __self: this, __source: {fileName: _jsxFileName, lineNumber: 14}}, user.UserKey)
      , _react2.default.createElement('td', {__self: this, __source: {fileName: _jsxFileName, lineNumber: 15}}, _react2.default.createElement(_Name2.default, { user: user, __self: this, __source: {fileName: _jsxFileName, lineNumber: 15}} ))
      , _react2.default.createElement('td', {__self: this, __source: {fileName: _jsxFileName, lineNumber: 16}}, user.Email)
      , _react2.default.createElement('td', { className: "bool", __self: this, __source: {fileName: _jsxFileName, lineNumber: 17}}, user.Activated ? 'yes' : 'no')
      , _react2.default.createElement('td', { className: "bool", __self: this, __source: {fileName: _jsxFileName, lineNumber: 18}}, user.Deleted ? 'yes' : 'no')
    )
  )
}

const SuperUsersScreen = () => {
  const [results, setResults] = _react.useState([])
  const [queryValue, setQueryValue] = _react.useState.call(void 0, "")
  const bounceTimeout = _react.useRef(undefined)

  const queryChange = _react.useCallback.call(void 0, (query) => {
    setQueryValue(query)
    clearTimeout(bounceTimeout.current)
    bounceTimeout.current = setTimeout(() => {
      _client2.default.send('SuperSearchUsers', { Query: _useSearchQuery.sanitizeSearchQuery.call(void 0, query) })
        .then((res) => {
          setResults(Object.values(res))
        }).catch(_log.log.error)
    }, 300)
  }, [])

  _react.useEffect.call(void 0, () => {
    queryChange("")
    // A pending search no longer fires after the screen closes.
    return () => clearTimeout(bounceTimeout.current)
  }, [queryChange])

  const rows = results.map((user) => _react2.default.createElement(UserResult, { user: user, key: user.UserKey, __self: this, __source: {fileName: _jsxFileName, lineNumber: 45}} ))

  return (
    _react2.default.createElement(_react2.default.Fragment, null
      , _react2.default.createElement('div', { className: "super--search-header", __self: this, __source: {fileName: _jsxFileName, lineNumber: 49}}
        , _react2.default.createElement(_Form.TextInput, {
          placeholder: "Search for users..."  ,
          wrapperClassName: "super--search-bar",
          onInput: e => queryChange(e.currentTarget.value),
          value: queryValue, __self: this, __source: {fileName: _jsxFileName, lineNumber: 50}}
        )
      )
      , _react2.default.createElement('table', { className: "super--table", __self: this, __source: {fileName: _jsxFileName, lineNumber: 57}}
        , _react2.default.createElement('thead', {__self: this, __source: {fileName: _jsxFileName, lineNumber: 58}}
          , _react2.default.createElement('tr', {__self: this, __source: {fileName: _jsxFileName, lineNumber: 59}}
            , _react2.default.createElement('th', {__self: this, __source: {fileName: _jsxFileName, lineNumber: 60}}, "User Key" )
            , _react2.default.createElement('th', {__self: this, __source: {fileName: _jsxFileName, lineNumber: 61}}, "Name")
            , _react2.default.createElement('th', {__self: this, __source: {fileName: _jsxFileName, lineNumber: 62}}, "Email")
            , _react2.default.createElement('th', {__self: this, __source: {fileName: _jsxFileName, lineNumber: 63}}, "Activated")
            , _react2.default.createElement('th', {__self: this, __source: {fileName: _jsxFileName, lineNumber: 64}}, "Deleted")
          )
        )
        , _react2.default.createElement('tbody', {__self: this, __source: {fileName: _jsxFileName, lineNumber: 67}}
          , rows
        )
      )
    )
  )
}

exports. default = SuperUsersScreen
